// extracted by mini-css-extract-plugin
export default {"wrap":"Lj6Le","btn":"dkD11","btn-wrap":"RoojW","btn-wrap--next":"cWYMK","btn-wrap--prev":"bWSY8","btn-wrap__icon":"FeN9Q"};